import React, { FC, useState } from 'react';

import { useIntl } from 'react-intl';

import { PlayCircle } from '@mui/icons-material';
import { BaseStyleEnums, ButtonType, ShortCodeEnums } from '@nhl/nhl-breakaway-ui';

import CommonMessages from '~/core/commonMessages';
import { useOptionForLocale } from '~/core/hooks/useOptionForLocale';
import { useShouldForceVideoLanguage } from '~/core/hooks/useShouldForceVideoLanguage';
import { useSizeWithThrottle } from '~/core/hooks/useSizeWithThrottle';
import StrictWidthText from '~/views/components/strictWidthText/StrictWidthText';
import VideoPlayer from '~/views/components/videoPlayer/VideoPlayer';
import { GameVideo } from '~/views/pages/gameCenter/types';

import { ButtonContainer, VideoButton } from './styles';

type Props = {
    gameVideo: GameVideo;
};

const RecapVideos: FC<Props> = ({ gameVideo }) => {
    const shouldForceVideoLanguage = useShouldForceVideoLanguage();
    const screenSize = useSizeWithThrottle();
    const intl = useIntl();

    const [videoId, setVideoId] = useState<number>();

    const isLarge = screenSize.width >= BaseStyleEnums.ScreenWidthBreakpoints.large;
    const clickHandler = (videoId: number) => () => {
        setVideoId(videoId);
    };

    const threeMinuteRecap = useOptionForLocale(
        {
            [ShortCodeEnums.Language.English]: gameVideo?.threeMinRecap,
            [ShortCodeEnums.Language.French]: gameVideo?.threeMinRecapFr,
        },
        shouldForceVideoLanguage
    );

    const condensedGame = useOptionForLocale(
        {
            [ShortCodeEnums.Language.English]: gameVideo?.condensedGame,
            [ShortCodeEnums.Language.French]: gameVideo?.condensedGameFr,
        },
        shouldForceVideoLanguage
    );

    return (
        <>
            {(condensedGame || threeMinuteRecap) && isLarge && (
                <ButtonContainer>
                    {threeMinuteRecap && (
                        <VideoButton variant={ButtonType.Secondary} onClick={clickHandler(threeMinuteRecap)}>
                            <PlayCircle />
                            <StrictWidthText text={intl.formatMessage(CommonMessages.linkDescriptions.recap)} />
                        </VideoButton>
                    )}
                    {condensedGame && (
                        <VideoButton variant={ButtonType.Secondary} onClick={clickHandler(condensedGame)}>
                            <PlayCircle />
                            <StrictWidthText text={intl.formatMessage(CommonMessages.linkDescriptions.condensed)} />
                        </VideoButton>
                    )}
                </ButtonContainer>
            )}
            {videoId && <VideoPlayer videoId={videoId} closePlayer={() => setVideoId(undefined)} />}
        </>
    );
};

export default RecapVideos;
